module.exports = __webpack_public_path__ + "a4a0722a246bd29a9cf3bd9f3922b7ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/vertex_pharmaceuticals_2023_chart.png
// module id = 1756
// module chunks = 0